import { useEffect, useState } from "react";

import { getAppInferenceConfiguration } from "pages/AppAi/client";
import { Flag } from "store/slices/featureFlags";

import { useFeatureFlag } from "./useFeatureFlag";

/**
 * Returns the org's preferred (default) AI integration ID, or `null` when
 * the feature is disabled, not yet configured, or loading.
 */
export function useDefaultAiIntegrationId(
  organizationId: string | undefined,
): string | null {
  const appAiEnabled = useFeatureFlag(Flag.APP_AI_DEFAULT_INTEGRATION_ENABLED);
  const [defaultId, setDefaultId] = useState<string | null>(null);

  useEffect(() => {
    setDefaultId(null);
    if (!appAiEnabled || !organizationId) return;
    let cancelled = false;
    getAppInferenceConfiguration(organizationId)
      .then((config) => {
        if (!cancelled) {
          setDefaultId(
            config.configured ? config.preferredIntegrationId : null,
          );
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [appAiEnabled, organizationId]);

  return defaultId;
}
